import slugify from '../slugify';
/**
 * Utilitná funkcia pre konverziu textu do formátu vhodného napr. pre url odstránením nepovolených znakov
 * @param {text} - String pre konverziu
 * @returns {string} - Upravený text
 * @example
 * ```javascript
 * import keyify from 'utilities/lib/keyify';
 *
 * const text = 'Utilitné funkcie Sportnet Online';
 * console.log(keyify(text)); // utilitne-funkcie-sportnet-online
 * ```
 */
function keyify(text) {
    if (!text) {
        return '';
    }
    return slugify(text).replace(/[^a-z0-9]/g, '-');
}
export default keyify;
